import { render, staticRenderFns } from "./LocksmithContent.vue?vue&type=template&id=70735ba2&scoped=true&"
import script from "./LocksmithContent.vue?vue&type=script&lang=js&"
export * from "./LocksmithContent.vue?vue&type=script&lang=js&"
import style0 from "./LocksmithContent.vue?vue&type=style&index=0&id=70735ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70735ba2",
  null
  
)

export default component.exports